// ABOUTME: Screen 2B Pick the Storm: the storm carousel is the stack's storm cloud; confirm_storm sends the focused storm.
// ABOUTME: The carousel opens on the stored storm, which is where Back from 2C lands.

import { useMemo } from 'react';
import { useCrossingContent } from '../../../hooks/useCrossingContent';
import type { ScreenProps, ScreenResult } from '../runner/screenContract';
import PickStatus from './carousel/PickStatus';
import { useCarouselIndex } from './carousel/useCarouselIndex';
import { useCarouselKeys } from './carousel/useCarouselKeys';

export default function Screen2B({ crossing }: ScreenProps): ScreenResult {
  const { data: content } = useCrossingContent();
  const storms = useMemo(() => Object.values(content?.storms ?? {}), [content]);
  const { focused, index, count, prev, next, browsed } = useCarouselIndex(storms, crossing.storm);
  useCarouselKeys(prev, next);

  return {
    layer: <PickStatus name={focused?.name} index={index} count={count} />,
    cloudTiers: { storm: { item: focused } },
    headline: 'Use the arrows to see which Storm was steering this time.',
    ...(focused && { picker: { label: focused.name, prevLabel: 'Previous storm', nextLabel: 'Next storm', onPrev: prev, onNext: next } }),
    slots: {
      confirm_storm: { disabled: !focused, values: focused ? { storm: focused.code } : undefined },
    },
    hasUnsentState: browsed && !!focused && focused.code !== crossing.storm,
  };
}
